FD.CONTROL = (function ($, me) {
    'use strict';

    var child = me.CONTROL || {};
    var VALIDATE_ELEM = '[data-validate="true"]';
    var VALIDATE_ELEM_FALSE = '[data-validate="false"]';
    var notify = new Notify();
    var label;

    // Default Regex Strings
    var REGEX = {
        EMAIL: new RegExp("^[a-zA-Z0-9.!#$%&’*+/=?^_`{|}~-]+@[a-zA-Z0-9-]+\.(?:[a-zA-Z0-9-]+)*$"),
        URL: new RegExp('^(ftp|http|https):\/\/[^ "]+$', "i")
    };


    /* ========================================================================
     *  private methods
     * ========================================================================
    */

    var setValidateEvent = function (container) {
        var requiredList;

        if (container) {
            container = $(container);
            requiredList = container.find('[required]');
        } else {
            requiredList = $('[required]');
        }

        requiredList.each(function (index, elem) {
            $(elem).closest('li').addClass('required');
        });

        //  this removes the required class from any parent li of elements that were required before, but are not anymore
        $(VALIDATE_ELEM_FALSE).removeClass('form-error').closest('li').removeClass('required');
        $(".required:not(span)", container).closest(".form-group").addClass("required");

        setValidateOnBlur();
    };


    function setValidateOnBlur() {
        $(document).on('blur', VALIDATE_ELEM, function (e) {
            if (validateInput(this)) {
                $(this).removeClass('form-error');
            } else {
                $(this).addClass('form-error');
                e.stopPropagation();
                e.preventDefault();
                e.cancelBubble = true;
                e.stopImmediatePropagation();
                return false;
            }
        });
    }


    function validateForm(container, customMessage, suppressAlert, validateHidden) {
        var list,
            validSubmit = true;

        if (container) {
            container = $(container);
            list = container.find(VALIDATE_ELEM);

            var validateIgnore = container.data("validate-ignore");
            if (validateIgnore) {
                list = $(list).filter(function () {
                    return $(this).closest(validateIgnore).length == 0;
                });
            }
            if (!validateHidden) {
                list = $(list).filter(function () {
                    return $(this).is(":visible");
                });
            }
        } else {
            list = $(VALIDATE_ELEM);
        }

        list.each(function (index, elem) {
            if (!validateInput(elem)) {
                validSubmit = false;
                $(elem).addClass('form-error');
            } else {
                $(elem).removeClass('form-error');
            }
        });

        if (!validSubmit && !suppressAlert) {
            notify.alert(customMessage ? customMessage : label['YouMustAddressAllRequiredFields']);
        }

        return validSubmit;
    }


    function validateInput(input) {
        var jqInput = $(input),
            value = input.value,
            match = jqInput.data('match'),
            required = jqInput.attr('required'),
            regex;
        
        if (jqInput.is('input')) {

            if (jqInput.attr('data-fd') === 'autocomplete') {
                if (!jqInput.data('initial') && !jqInput.data('value')) return false;
                else return true;
            }

            if (!value || !value.trim()) { // input is empty
                return required ? false : true;
            }

            var tempRegex = REGEX[jqInput.attr('type').toUpperCase()];

            if (tempRegex) {
                regex = tempRegex;
            } else if (match) {
                regex = new RegExp(match);
            }
            if (regex) {
                if (jqInput.attr('type').toUpperCase() === 'URL' && !value.match(regex)) {
                    return ('http://' + value).match(regex);
                } 
                return value.match(regex);
            } else { // just checking to make sure field isn't empty
                return true;
            }
        } else if (jqInput.is('select')) {
            var validateAgainst = jqInput.data('validatevalue');
            if (validateAgainst === undefined) {
                validateAgainst = -1;
            }
            if (!required || (value && Number(value) !== Number(validateAgainst))) {
                return true;
            } else {
                return false;
            }
        } else if (jqInput.is('textarea')) {
            if (!value || !value.trim()) { // check if empty
                return !required;
            } else {
                if (match) {
                    regex = new RegExp(match);
                    return value.match(regex);
                } else { // field has text
                    return true;
                }
            }
        }
    }
    


    /* ========================================================================
     *  Public Methods
     * ========================================================================
    */

    
    child.setValidateContainer = function (container) {
        label = label || me.getLabel();

        setValidateEvent(container);
    };


    child.Validate = function (container, customMessage, suppressAlert, validateHidden) {
        return validateForm(container, customMessage, suppressAlert, validateHidden);
    };


    child.validate = function (container, customMessage, suppressAlert, validateHidden) {
        return validateForm(container, customMessage, suppressAlert, validateHidden);
    };


    /* ========================================================================
     *  return
     * ========================================================================
    */
    return child;
}(jQuery, FD));